import logoImage from "../../assest/images/logo-img.png"
import { Link } from "react-router-dom";
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png";
import LastBox from "../../components/LastBox";
import "../../assest/css/login.css";
import ProviderList from "../../components/ProviderList";
import helper from "../../common/Helper";

const Index = ({ state, login, changeValue, showPassword ,handhandleShowPassword,isLoading }) => {
    const {
        error, email, password
    } = state;
    return (
        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                {/* <a href="#" className="sq-logo">
                    <div className="sq-logo-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <span className="sq-logo-text">SoftQA</span>
                </a> */}

                <div className="sq-form-section">
                    <h1 className="sq-heading">Let’s login to your <br /> account first</h1>
                    {/* <p className="sq-subheading">Access your dashboard to manage tours, bookings, and availability.</p> */}
                    <form onSubmit={login}>
                        <div className="sq-input-wrap">
                            <label className="sq-label" htmlFor="sq-email">Email</label>
                            <div style={{position:"relative"}}>
                                <span className="sq-input-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </span>
                                <input id="sq-email" className="sq-input" name="email" type="email" value={email} placeholder="Enter your email" onChange={changeValue} required />
                                {error && error.email && <span className="cus-err login-err">{error.email}</span>}
                            </div>
                        </div>

                        <div className="sq-input-wrap">
                            <label className="sq-label" htmlFor="sq-password">Password</label>
                            <div style={{position:"relative"}}>
                                <span className="sq-input-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0110 0v4" />
                                    </svg>
                                </span>
                                <input id="sq-password" name="password" className="sq-input" type={!showPassword ? 'password' : 'text'} value={password} placeholder="Enter Password" onChange={changeValue} style={{ paddingRight: "2.75rem" }} required />
                                <button className="sq-pw-toggle" onClick={handhandleShowPassword} type="button" aria-label="Toggle password">
                                    {showPassword ? <i className="fa-solid fa-eye-slash" onClick={handhandleShowPassword}></i> : <i className="fa-solid fa-eye" onClick={handhandleShowPassword}></i>}
                                </button>

                                {/* <button className="btn btnShow" type="button">
                                    {
                                        showPassword ? <i className="fa-solid fa-eye-slash" onClick={handhandleShowPassword}></i> : <i className="fa-solid fa-eye" onClick={handhandleShowPassword}></i>
                                    }


                                </button> */}
                                {error && error.password && <span className="cus-err login-err">{error.password}</span>}
                            </div>
                        </div>

                        <div className="sq-forgot"><Link to={"/forgot-password"}>Forgot Password?</Link></div>

                        <button className="common-btn sq-btn-primary" disabled={isLoading} type="submit">
                            {isLoading ? "Loading..." : "Login"}
                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}
                        </button>
                    </form>
                    <div className="sq-divider">OR</div>

                    {/* <button className="sq-btn-social" type="button">
                        <svg width="18" height="18" viewBox="0 0 48 48">
                            <path fill="#FFC107" d="M43.6 20H24v8h11.3c-1.1 4.7-5.3 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.7 29.3 4.8 24 4.8 12.3 4.8 3 14.1 3 25.8s9.3 21 21 21c10.7 0 20-7.7 20-21 0-1.3-.1-2.6-.4-3.8z" />
                            <path fill="#FF3D00" d="M6.3 14.9l6.6 4.8C14.6 15.5 19 12 24 12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.7 29.3 4.8 24 4.8c-8.2 0-15.2 4.7-18.5 11.4-.3.6-.6 1.2-.8 1.9z" transform="translate(-3 12)" />
                            <path fill="#4CAF50" d="M24 48c5.2 0 9.9-1.7 13.6-4.7l-6.3-5.3C29.3 39.6 26.8 40 24 40c-5.9 0-10.9-3.8-12.8-9l-6.5 5c3.3 6.6 10.2 11 19.3 11z" transform="translate(0 0)" />
                            <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.5 2.2-1.7 4.2-3.4 5.7l6.3 5.3C42.4 35.5 44 30.1 44 24c0-1.3-.1-2.6-.4-3.8z" transform="translate(0 0)" />
                        </svg>
                        Continue with Google
                    </button>

                    <button className="sq-btn-social" type="button">
                        <svg width="18" height="18" viewBox="0 0 814 1000">
                            <path fill="#555" d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.9-155.5-127.2c-43.2-81.1-66.5-231.6-66.5-287.8 0-222 145.1-338.3 289.5-338.3 76 0 139.3 50.2 186.7 50.2 45.5 0 116.7-53.4 200.6-53.4zm-192-130.3c35.4-41.9 59.1-99.3 59.1-156.7 0-8-1.3-16.1-1.9-20.1-56.4 2.2-123.7 37.4-163.8 85.1-31.3 36.5-61 94.5-61 153.2 0 8.7 1.3 17.3 1.9 19.9 3.2.6 8.4 1.3 13.6 1.3 49.9 0 113.4-33.1 151.3-82.6z" />
                        </svg>
                        Continue with Apple
                    </button> */}

                    <p className="sq-signup-link">Don't have an account? <Link to={"/signup"}>Register Here</Link></p>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        {/* <span className="sq-big-quote">"</span> */}
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                        {/* <div className="sq-quote-author">
                            <div className="sq-author-avatar">MC</div>
                            <div>
                                <div className="sq-author-name">Michael Carter</div>
                                <div className="sq-author-role">Software Engineer at DevCore</div>
                            </div>
                        </div> */}
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                        {/* <span className="sq-brand-name">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{opacity:0.6}}><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.042.03.052a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z" /></svg>
                            Bokun
                        </span>
                        <span className="sq-brand-name">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{opacity:0.6}}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" /></svg>
                            Fareharbor
                        </span>
                        <span className="sq-brand-name">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{opacity:0.6}}><path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" /></svg>
                            Pluralo
                        </span>
                        <span className="sq-brand-name">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{opacity:0.6}}><path d="M3 3h18v18H3V3zm16 16V5H5v14h14z" /></svg>
                            Rezdy
                        </span> */}
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Index;
